import { render, staticRenderFns } from "./suGroupReport.vue?vue&type=template&id=3822666c"
import script from "./suGroupReport.vue?vue&type=script&lang=js"
export * from "./suGroupReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports